





































import { Vue, Component } from 'vue-property-decorator'
const AppProps = Vue.extend({
  props: {
  }
})

@Component({
  components: {
  }
})

export default class App extends AppProps {
  links = [
    {
      id: 1,
      text: 'Roskilde',
      page: '/Events'
    },
    /*
    {
      id: 2,
      text: 'Hjælp',
      page: '/Help'
    },
    */
    {
      id: 3,
      text: 'Our stable mates',
      page: '/About'
    },
    {
      id: 4,
      text: 'Kontakt',
      page: '/Contact'
    }
  ]
}
